module.exports = __webpack_public_path__ + "static/media/indigo.1cabcf19.svg";